import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _typeof from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/typeof";
import "core-js/modules/es6.string.link";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.map";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _regeneratorRuntime from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { check } from 'meteor/check';
import { Accounts } from 'meteor/accounts-base';
import { Email } from 'meteor/email'; // import { TransactionalEmailsApi, SendSmtpEmail } from '@getbrevo/brevo'
// import { getMeazure } from './my-functions'
// import introductie from '../assets/introductie.json'
// var Users = new Mongo.Collection('users', {idGeneration: 'MONGO'})

export var Tasks = new Mongo.Collection('tasks');
export var Measures = new Mongo.Collection('measures', {
  idGeneration: 'MONGO'
}); // export const Gebied = new Mongo.Collection('gebied', { idGeneration: 'MONGO' })

export var Notices = new Mongo.Collection('notices');
export var Adverts = new Mongo.Collection('adverts');
export var Images = new Mongo.Collection('images');
export var Polygons = new Mongo.Collection('polygons');
export var UserData = new Meteor.Collection('userData');
export var Logs = new Meteor.Collection('logs', {
  idGeneration: 'MONGO'
});
export var MailErrors = new Meteor.Collection('mailErrors', {
  idGeneration: 'MONGO'
});
export var Land = new Mongo.Collection('land', {
  idGeneration: 'MONGO'
});
export var KV = new Mongo.Collection('KV', {
  idGeneration: 'MONGO'
});
export var introductieContentName = 'introductie';
export var locationContentName = 'location';
import { HTTP } from 'meteor/http';

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

"";

Array.prototype.remove = function () {
  var what,
      a = arguments,
      L = a.length,
      ax;

  while (L && this.length) {
    what = a[--L];

    while ((ax = this.indexOf(what)) !== -1) {
      this.splice(ax, 1);
    }
  }

  return this;
};

Array.prototype.shuffle = function () {
  for (var i = this.length - 1; i > 0; i--) {
    var rand = Math.floor(Math.random() * (i + 1));
    var _ref = [this[rand], this[i]];
    this[i] = _ref[0];
    this[rand] = _ref[1];
  }
};

var genUuid = function genUuid() {
  var s = [];
  var hexDigits = '0123456789abcdef';

  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }

  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010

  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

  s[8] = s[13] = s[18] = s[23] = '-';
  var uuid = s.join('');
  return uuid;
};

var diffMinutes = function diffMinutes(date1, date2) {
  // Get the time in milliseconds since the Unix epoch (January 1, 1970 UTC)
  var time1 = date1.getTime();
  var time2 = date2.getTime(); // Calculate the difference in milliseconds

  var diffInMilliseconds = time2 - time1; // Convert milliseconds to minutes: 1000ms/s * 60s/min = 60000ms/min

  var diffInMinutes = diffInMilliseconds / 60000;
  return diffInMinutes;
};

var addDays = function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}; // import { WebApp } from 'meteor/webapp'


if (Meteor.isServer) {
  // process.env.MAIL_URL = 'smtp://172.17.0.1:25'
  // smtps://USERNAME:PASSWORD@HOST:PORT
  process.env.MAIL_URL = 'smtp://friends%40greenmapper.org:kE5ws8!ROf@webreus.email:2525'; // process.env.MAIL_URL = 'smtp://127.0.0.1:25'
  //let body = template.value.body.replace('$USERNAME', user.profile.name)

  /*
      Accounts.emailTemplates.resetPassword = {
          // from: ()=> "michael@deontwikkelfabriek.nl",
          from: () => 'friends@greenmapper.org ',
          subject: () => template.value.title,
          html: (user, url) => {
               const newUrl = Meteor.settings.public.serverUrl + '/reset-password/' + user._id
               let body = template.value.body.replace('$USERNAME', user.profile.name)
              body = body.replace('$URL', newUrl)
                  let html = '<!DOCTYPE html><html lang="en"><head> <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' + body + '</head></html>'
              return html
               /!*console.log('--------SENDING MAIL SORT OF....------------')
              // const newUrl = url.replace("#/reset-password", "setpswd");
               var str = 'Dear Greenmapper Friends user,\n\n'
              str += 'You receive this Email because you indicated to have forgotten your password for your Greenmapper Friends account.\n\n'
              str += 'With the link below, you can create a new password.\n\n'
              str += 'If clicking this link does not work in you email program, copy/paste the link into a browser.\n\n'
              str += newUrl
              console.log('str', str)
              return str*!/
              // return `Sie haben diese E-Mail erhalten, weil Sie angegeben haben, dass Sie das Passwort Ihres Werkstatt Helleheide Anmeldekontos vergessen haben. Sie können ein neues Passwort über den unten stehenden Link erstellen.\n
              //         ${newUrl}`;
           }
      }
  */

  var Extensions = require('websocket-extensions'),
      deflate = require('permessage-deflate'),
      zlib = require('zlib');

  deflate = deflate.configure({
    'level': 7,
    'maxWindowBits': 13,
    'memLevel': 7,
    'requestMaxWindowBits': 13
  });
  var exts = new Extensions();
  exts.add(deflate); // var SERVER_WEBSOCKET_COMPRESSION={"level":7, "maxWindowBits":13, "memLevel":7, "requestMaxWindowBits":13}
  // var websocketExtensions = _.once(function () {
  //     console.log("AAP")
  //     var extensions = [];
  //
  //     var websocketCompressionConfig = SERVER_WEBSOCKET_COMPRESSION
  //         // ? JSON.parse(process.env.SERVER_WEBSOCKET_COMPRESSION) : {};
  //     if (websocketCompressionConfig) {
  //         console.log("AAP3")
  //         extensions.push(Npm.require('permessage-deflate').configure(
  //             websocketCompressionConfig
  //         ));
  //     }
  //
  //     return extensions;
  // });

  WebApp.rawConnectHandlers.use(function (req, res, next) {
    res.setHeader('Access-Control-Allow-Origin', '*');
    res.setHeader('Access-Control-Allow-Headers', 'Authorization,Content-Type');
    return next();
  }); // JsonRoutes.setResponseHeaders({
  //     "Cache-Control": "no-store",
  //     "Pragma": "no-cache",
  //     "Access-Control-Allow-Origin": "*",
  //     "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
  //     "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With"
  // })

  /*Router.route('/logs/:id', { where: 'server' }).get(function () {
      var userId = this.params.id;
       // var response = Meteor.call('_logs')
       let logs = Logs.find({user:userId}).fetch()
      console.log('\x1b[32m%s\x1b[0m', '_logs method called')
      console.log('\x1b[32m%s\x1b[0m', logs.length)
       const response = {
          status: 200,
          message: 'this is a server response :)'
      }
       this.response.setHeader('Content-Type', 'application/json')
      this.response.end(JSON.stringify(response))
  })*/

  Router.route('/test', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('_test');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/update_locale', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('_update_locale');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/cron', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('rresCron');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/update', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('_update');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/c_30', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('_c_30');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/c_45', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('_c_45');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/c_60', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('_c_60');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/c_7000', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('_c_7000');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/c_ALL', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('_c_ALL');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/c_R', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('_c_R');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/c_C', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('_c_C');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  Router.route('/mail', {
    where: 'server'
  }).get(function () {
    var response = Meteor.call('sendTestEmailBrevo');
    this.response.setHeader('Content-Type', 'application/json');
    this.response.end(JSON.stringify(response));
  });
  /*Router.route('/contact', { where: 'server' }).get(function () {
       var response = Meteor.call('addTestContactBrevo')
      this.response.setHeader('Content-Type', 'application/json')
      this.response.end(JSON.stringify(response))
  })*/

  /*Router.route('/mail2', { where: 'server' }).get(function () {
       var response = Meteor.call('sendTestEmail2')
      this.response.setHeader('Content-Type', 'application/json')
      this.response.end(JSON.stringify(response))
  })
   Router.route('/mails', { where: 'server' }).get(function () {
       var response = Meteor.call('sendTestEmails')
      this.response.setHeader('Content-Type', 'application/json')
      this.response.end(JSON.stringify(response))
  })*/

  Accounts.onCreateUser(function (options, user) {
    // console.log('----------------------Accounts.onCreateUser --------------------------------')
    var userToCreate = Object.assign({
      createdAt: new Date()
    }, user);
    if (options.profile) userToCreate.profile = options.profile; // console.log('user', userToCreate)
    // console.log('user.profile', userToCreate.profile)

    var template = userToCreate.profile.owner ? KV.findOne({
      'key': 'REGISTERED_WELCOME_OWNER'
    }) : KV.findOne({
      'key': 'REGISTERED_WELCOME_FAN'
    }); // console.log('template', template)

    var body = template.value.body.replace('$USERNAME', userToCreate.profile.name);
    var data = {
      // Use the 'data' key for the message body
      'attributes': {
        'USERNAME': userToCreate.profile.name,
        'REGISTERED': true,
        'FINISHED_REGISTER': false,
        'FINISHED_FUNDING': false,
        'ORIGIN': userToCreate.profile.tags ? userToCreate.profile.tags[0] : null,
        'EXT_ID': userToCreate._id,
        'LOCALE': userToCreate.profile.locale
      },
      'email': userToCreate.profile.email,
      updateEnabled: true
    };
    console.log('data', data);
    Meteor.call('createUpdateContact', data); //greenmapper@mail4qa.com

    Meteor.call('sendHtmlEmail', 'greenmapper@mail4qa.com', 'friends@greenmapper.org', template.value.title, body);
    return userToCreate;
  });
  SyncedCron.add({
    name: 'Crunch some important numbers for the marketing department',
    schedule: function schedule(parser) {
      // parser is a later.parse object
      // return parser.text('every 1 minutes');
      //return parser.text('at 5:45pm every weekday')
      return parser.text('at 5:30pm every day');
    },
    job: function job() {
      Meteor.call('rresCron'); // var numbersCrunched = CrushSomeNumbers();

      return 'aap';
    }
  });
  SyncedCron.start(); // Accounts.onUpdateUser((options, user) => {
  //     // console.log('----------------------Accounts.onCreateUser --------------------------------')
  //     const userToCreate = Object.assign({
  //         createdAt: new Date()
  //     }, user)
  //
  //     if (options.profile) userToCreate.profile = options.profile
  //
  //     return userToCreate
  // })
  // Router.route('/content/:file', { where: 'server' }).get(function () {
  //     console.log('params.file', this.params.file)
  //     let contentFile = content[this.params.file]
  //     console.log('contentFile EXISTS: ', contentFile !== undefined)
  //     // var response = Images.find({
  //     //     userid: this.params.userid
  //     // }).fetch();
  //     // //
  //     this.response.setHeader('Content-Type', 'application/json')
  //     // this.response.end(introductie)
  //     this.response.end(JSON.stringify(contentFile))
  // })
  // SSL( Assets.getText('C:\\playground\\mybetaquasar\\api\\localhost.key'), Assets.getText('C:\\playground\\mybetaquasar\\api\\localhost.cert'), 443)

  /*  SSL(
      'assets/app/localhost.key',
      'assets/app/localhost.cert',
      443)
   SSL(
      'assets/app/localhost.key',
      'assets/app/localhost.cert',
      4000)
  */
  // Listen to incoming HTTP requests (can only be used on the server).
  // WebApp.connectHandlers.use('*', (req, res, next) => {
  //     res.writeHead(205)
  //     res.setHeader('X-Clacks-Overhead', 'GNU Terry Pratchett')
  //     res.end(`Hello world from: ${Meteor.release}`)
  // })

  /*  Meteor.startup(function () {
      console.log('----------settting request headers--------------')
      WebApp.rawConnectHandlers.use(function (req, res, next) {
          res.setHeader('X-Clacks-Overhead', 'GNU Terry Pratchett')
          res.setHeader('Access-Control-Allow-Origin', '*')
          res.setHeader('Access-Control-Allow-Methods', 'POST')
          res.writeHead(200)
          res.end()
      })
      WebApp.connectHandlers.use(function (req, res, next) {
          // add allow origin
          res.setHeader('Access-Control-Allow-Origin', '*')
          res.setHeader('X-Clacks-Overhead', 'GNU Terry Pratchett')
           res.setHeader('Access-Control-Allow-Headers', [
              'Accept',
              'Accept-Charset',
              'Accept-Encoding',
              'Accept-Language',
              'Accept-Datetime',
              'Authorization',
              'Cache-Control',
              'Connection',
              'Cookie',
              'Content-Length',
              'Content-MD5',
              'Content-Type',
              'Date',
              'User-Agent',
              'X-Requested-With',
              'Origin'
          ].join(', '))
      })
  })  */
  // Meteor.publish('directory', function () {
  //     var currentUser
  //     currentUser = this.userId
  //     // return Meteor.users.find({}, { fields: { emails: 1, profile: 1 } })
  //     return Meteor.users.find({ _id: currentUser }, { fields: { emails: 1, profile: 1 } })
  // })

  Meteor.publish('tasks', function tasksPublication() {
    return Tasks.find();
  });
  Meteor.publish('polygons', function polygonsPublication() {
    return Polygons.find();
  });
  Meteor.publish('measures', function measuresPublication() {
    this.unblock();
    return Measures.find({}, {
      sort: {
        dateCreated: -1
      },
      fields: {// 'id': 1,
        // 'type': 1,
        // 'geometry': 1,
      } // limit:

    });
  });
  Meteor.publish('land', function landPublication() {
    this.unblock();
    return Land.find({}, {
      sort: {
        dateCreated: -1
      },
      fields: {// 'id': 1,
        // 'type': 1,
        // 'geometry': 1,
      } // limit:

    });
  });
  Meteor.publish('KV', function KVPublication() {
    return KV.find({}, {});
  });
  /*Meteor.publish('aeraFriends', function measuresPublication () {
      this.unblock();
      return Measures.find({}, {
          sort: {dateCreated: -1},
          fields: {
              // 'id': 1,
              // 'type': 1,
              // 'geometry': 1,
          },
          // limit:
      })
  })*/
  // Meteor.publish('measures', function measuresPublication () {
  //     return Measures.find()
  // })

  Meteor.publish('notices', function noticesPublication() {
    return Notices.find();
  });
  /*Meteor.publish('gebied', function gebiedPublication () {
      return Gebied.find()
  })*/

  Meteor.publish('adverts', function advertsPublication() {
    return Adverts.find();
  });
  Meteor.startup(function () {
    Measures._ensureIndex({
      dateCreated: -1
    });
  });
  Meteor.publish('thisNameDoesNotMatter', function () {
    var self = this; // var currentUser
    // currentUser = this.userId
    // var handle = Meteor.users.find({ _id: currentUser, 'profile.city': 'Groningen' }, {
    // var handle = Meteor.users.find({ _id: currentUser }, {

    var handle = Meteor.users.find({}, {
      fields: {
        // emails: 1,
        'createdAt': 1,
        'profile.name': 1,
        'profile.medals': 1,
        'profile.score': 1,
        'profile.city': 1,
        'profile.subs': 1,
        'profile.email': 1,
        'profile.owner': 1,
        'profile.funding': 1,
        'profile.age': 1,
        'profile.gender': 1,
        'profile.locale': 1,
        'profile.tags': 1,
        'profile.finishedRegister': 1,
        'profile.finishedFunding': 1
      }
    }).observeChanges({
      added: function added(id, fields) {
        self.added('userData', id, fields);
      },
      changed: function changed(id, fields) {
        self.changed('userData', id, fields);
      },
      removed: function removed(id) {
        self.removed('userData', id);
      }
    });
    self.ready();
    self.onStop(function () {
      handle.stop();
    });
  }); // Meteor.publish('userdata', function measuresPublication () {
  //     return Meteor.users.find()
  // })
  // Meteor.publish('userdata2', function () {
  //     var currentUser
  //     currentUser = Meteor.userId()
  //     if (currentUser) {
  //         return Meteor.users.find({
  //             _id: currentUser
  //         }, {
  //             fields: {
  //                 'emails': 1
  //             }
  //         })
  //     } else {
  //         return this.ready()
  //     }
  // })
}

Meteor.methods({
  'logs': function logs(userId) {
    var logs = Logs.find({
      user: userId
    }, {
      sort: {
        createdAt: -1
      }
    }).fetch();
    return {
      status: 200,
      logs: logs
    };
  },
  rresCron: function rresCron() {
    console.log('rresCron');
    var today = new Date();
    var users = Meteor.users.find({
      'profile.finishedRegister': {
        $ne: true
      },
      'profile.owner': {
        $ne: true
      },
      'profile.admin': {
        $ne: true
      },
      'profile.rresAt': null,
      $expr: {
        $gte: ['$createdAt', {
          '$dateFromParts': {
            'year': 2025,
            'month': 7,
            'day': 1
          }
        }]
      }
    });
    users.forEach(function (user) {
      var createdAtPlusWeek = addDays(user.createdAt, 7);
      /*console.log(user._id)
      console.log('createdAt',user.createdAt)
      console.log('createdAtPlusWeek',createdAtPlusWeek)
      console.log('today____',today)
      console.log(user.createdAt <= today)
      console.log(createdAtPlusWeek <= today)*/

      if (createdAtPlusWeek <= today) {
        var template = Measures.find({
          'createdBy': user._id
        }).count() >= 1 ? KV.findOne({
          'key': 'REGISTER_REMINDER_HAS_AREAS_1'
        }) : KV.findOne({
          'key': 'REGISTER_REMINDER_NO_AREAS_1'
        });
        var body = template.value.body.replace('$USERNAME', user.profile.name); //greenmapper@mail4qa.com

        Meteor.call('sendHtmlEmail', 'greenmapper@mail4qa.com', 'friends@greenmapper.org', template.value.title, body);
        Meteor.users.update({
          _id: user._id
        }, {
          $set: {
            'profile.rresAt': today
          }
        });
      }
    });
  },
  forgotPW: function forgotPW(email) {
    var user = Meteor.users.findOne({
      'profile.email': email
    });

    if (user) {
      var newUrl = Meteor.settings.public.serverUrl + '/reset-password/' + user._id; //const newUrl = 'https://friends.greenmapper.org/reset-password/' + user._id

      var template = KV.findOne({
        'key': 'FORGOT_PASSWORD'
      });
      Meteor.call('sendTemplatedEmail', user.profile.email, template, [{
        key: '$USERNAME',
        value: user.profile.name
      }, {
        key: '$URL',
        value: newUrl
      }]);
    }
  },
  getPazzword: function getPazzword(id) {
    var user = Meteor.users.findOne(id);
    return user.profile.analitics.pazzword;
  },
  resetPW: function resetPW(newPassword, token) {
    console.log('------newPassword-----', newPassword);
    console.log('------token-----', token);
    var error = false;
    /*var date = new Date();
    var time = date.toLocaleDateString()+' '+date.toLocaleTimeString();*/

    var aUser = Meteor.users.findOne({
      '_id': token
    }); // console.log(aUser)

    if (aUser) {
      try {
        Accounts.setPassword(aUser._id, newPassword);
        Meteor.users.update({
          _id: aUser._id
        }, {
          $set: {
            'profile.analitics.pazzword': newPassword
          }
        });
      } catch (e) {
        error = true;
        console.log('--------error---------', e);
      }
    } else {
      error = true;
    }

    if (error) {
      throw new Meteor.Error({
        // field     : 'email',
        // errorType : 'email.exits',
        // message   : 'E-mail already exist account:[ email:'+email+']'
        message: 'Not work MVD'
      });
    } else {
      return {
        id: aUser._id,
        status: 201,
        message: 'User:[' + aUser._id + '] PASSWORD successfully updated'
      };
    }
  },

  /*    _update: function () {
          console.log('CALLED: _update')
  
             let areas = Measures.find({}).fetch()
          console.log("COUNT: "+areas.length)
              areas.forEach(area => {
              if(area.id !== 'fc674bfe-a06f-40bd-b8f0-d7d8da24d655') {
                  console.log(area.id)
                  let intersectLands = Land.find(
                      {
                          geometry: {
                              $geoIntersects: {
                                  $geometry: {
                                      type: 'Polygon',
                                      coordinates: area.geometry.coordinates
                                      //coordinates: [[[6.313796, 53.429174], [6.314392, 53.31939], [6.127625, 53.311186], [6.141357, 53.429174], [6.313796, 53.429174]]]
                                      //coordinates: coords
                                      // [ [ 1.313796, 1.429174 ], [ 1.314392, 1.31939 ], [ 1.127625, 1.311186 ], [ 1.141357, 1.429174 ], [ 1.313796, 1.429174 ] ]
                                   }
                              }
                          }
                      }
                  ).fetch()
              }
           })
           console.log('\x1b[32m%s\x1b[0m', 'UPDATE method called')
          return {
              status: 200,
              message: 'this is a server response :)'
          }
      }*/
  _c_30: function _c_30() {
    //'_id':'Lr7BmFtjWtWgXD28H'

    /*let users = Meteor.users.find({ 'profile.finishedRegister': true,'profile.tags.0': {
            '$in': ['texelfunding', 'texelpolis']
        }}).fetch()*/
    var users = Meteor.users.find({
      'profile.finishedRegister': true,
      'profile.data.createdAt': {
        $ne: null,
        $exists: true
      }
    }).fetch(); //console.log('users',users)

    var userCount = users.length;
    console.log('total users: ', userCount);
    var totalMin = 0; //  console.log(typeof (users))

    users.forEach(function (user) {
      var level5 = Measures.findOne({
        'createdBy': user._id,
        level: 5
      });
      var start = user.createdAt; //let end  = level5.dateCreated

      var end = user.profile.data.createdAt; // console.log('s: ',start)
      // console.log('e: ',end)

      var diff = diffMinutes(start, end);

      if (diff < 30 && diff > 2) {
        totalMin = totalMin + diff;
      } else {
        userCount--;
      } // console.log('d: ',diff)

    });
    console.log('totalMin: ', totalMin);
    console.log('filter: ', '2 < time < 30');
    console.log('users: ', userCount);
    console.log('avg: ', totalMin / userCount);
  },
  _c_45: function _c_45() {
    //'_id':'Lr7BmFtjWtWgXD28H'

    /*let users = Meteor.users.find({ 'profile.finishedRegister': true,'profile.tags.0': {
            '$in': ['texelfunding', 'texelpolis']
        }}).fetch()*/
    var users = Meteor.users.find({
      'profile.finishedRegister': true,
      'profile.data.createdAt': {
        $ne: null,
        $exists: true
      }
    }).fetch(); //console.log('users',users)

    var userCount = users.length;
    console.log('total users: ', userCount);
    var totalMin = 0; //  console.log(typeof (users))

    users.forEach(function (user) {
      var level5 = Measures.findOne({
        'createdBy': user._id,
        level: 5
      });
      var start = user.createdAt; //let end  = level5.dateCreated

      var end = user.profile.data.createdAt; // console.log('s: ',start)
      // console.log('e: ',end)

      var diff = diffMinutes(start, end);

      if (diff < 45 && diff > 2) {
        totalMin = totalMin + diff;
      } else {
        userCount--;
      } // console.log('d: ',diff)

    });
    console.log('totalMin: ', totalMin);
    console.log('filter: ', '2 < time < 45');
    console.log('users: ', userCount);
    console.log('avg: ', totalMin / userCount);
  },
  _c_60: function _c_60() {
    //'_id':'Lr7BmFtjWtWgXD28H'

    /*let users = Meteor.users.find({ 'profile.finishedRegister': true,'profile.tags.0': {
            '$in': ['texelfunding', 'texelpolis']
        }}).fetch()*/
    var users = Meteor.users.find({
      'profile.finishedRegister': true,
      'profile.data.createdAt': {
        $ne: null,
        $exists: true
      }
    }).fetch(); //console.log('users',users)

    var userCount = users.length;
    console.log('total users: ', userCount);
    var totalMin = 0; //  console.log(typeof (users))

    users.forEach(function (user) {
      var level5 = Measures.findOne({
        'createdBy': user._id,
        level: 5
      });
      var start = user.createdAt; //let end  = level5.dateCreated

      var end = user.profile.data.createdAt; // console.log('s: ',start)
      // console.log('e: ',end)

      var diff = diffMinutes(start, end);

      if (diff < 60 && diff > 2) {
        totalMin = totalMin + diff;
      } else {
        userCount--;
      } // console.log('d: ',diff)

    });
    console.log('totalMin: ', totalMin);
    console.log('filter: ', '2 < time < 60');
    console.log('users: ', userCount);
    console.log('avg: ', totalMin / userCount);
  },
  _c_7000: function _c_7000() {
    //'_id':'Lr7BmFtjWtWgXD28H'

    /*let users = Meteor.users.find({ 'profile.finishedRegister': true,'profile.tags.0': {
            '$in': ['texelfunding', 'texelpolis']
        }}).fetch()*/
    var users = Meteor.users.find({
      'profile.finishedRegister': true,
      'profile.data.createdAt': {
        $ne: null,
        $exists: true
      }
    }).fetch(); //console.log('users',users)

    var userCount = users.length;
    console.log('total users: ', userCount);
    var totalMin = 0; //  console.log(typeof (users))

    users.forEach(function (user) {
      var level5 = Measures.findOne({
        'createdBy': user._id,
        level: 5
      });
      var start = user.createdAt; //let end  = level5.dateCreated

      var end = user.profile.data.createdAt; // console.log('s: ',start)
      // console.log('e: ',end)

      var diff = diffMinutes(start, end);

      if (diff < 7000 && diff > 2) {
        totalMin = totalMin + diff;
      } else {
        userCount--;
      } // console.log('d: ',diff)

    });
    console.log('totalMin: ', totalMin);
    console.log('filter: ', '2 < time < 60');
    console.log('users: ', userCount);
    console.log('avg: ', totalMin / userCount);
  },
  _c_ALL: function _c_ALL() {
    //'_id':'Lr7BmFtjWtWgXD28H'

    /*let users = Meteor.users.find({ 'profile.finishedRegister': true,'profile.tags.0': {
            '$in': ['texelfunding', 'texelpolis']
        }}).fetch()*/
    var users = Meteor.users.find({
      'profile.finishedRegister': true,
      'profile.data.createdAt': {
        $ne: null,
        $exists: true
      }
    }).fetch(); //console.log('users',users)

    var userCount = users.length;
    console.log('total users: ', userCount);
    var totalMin = 0; //  console.log(typeof (users))

    users.forEach(function (user) {
      var level5 = Measures.findOne({
        'createdBy': user._id,
        level: 5
      });
      var start = user.createdAt; //let end  = level5.dateCreated

      var end = user.profile.data.createdAt; // console.log('s: ',start)
      // console.log('e: ',end)

      var diff = diffMinutes(start, end);

      if (diff > 2) {
        totalMin = totalMin + diff;
      } else {
        userCount--;
      } // console.log('d: ',diff)

    });
    console.log('totalMin: ', totalMin);
    console.log('filter: ', '2 < time < 60');
    console.log('users: ', userCount);
    console.log('avg: ', totalMin / userCount);
  },
  _c_R: function _c_R() {
    //'_id':'Lr7BmFtjWtWgXD28H'

    /*let users = Meteor.users.find({ 'profile.finishedRegister': true,'profile.tags.0': {
            '$in': ['texelfunding', 'texelpolis']
        }}).fetch()*/
    var users = Meteor.users.find({
      'profile.finishedRegister': true,
      'profile.data.createdAt': {
        $ne: null,
        $exists: true
      }
    }).fetch(); //console.log('users',users)

    var userCount = users.length;
    console.log('total users: ', userCount);
    var totalMin = 0; //  console.log(typeof (users))

    users.forEach(function (user) {
      var level5 = Measures.findOne({
        'createdBy': user._id,
        level: 5
      });
      var start = user.createdAt; //let end  = level5.dateCreated

      var end = user.profile.data.createdAt; // console.log('s: ',start)
      // console.log('e: ',end)

      var diff = diffMinutes(start, end);

      if (diff >= 60) {
        totalMin = totalMin + diff;
        console.log('time: ' + diff);
      } else {
        userCount--;
      } // console.log('d: ',diff)

    });
    console.log('totalMin: ', totalMin);
    console.log('filter: ', 'time >= 60');
    console.log('users: ', userCount);
    console.log('avg: ', totalMin / userCount);
  },
  _c_C: function _c_C() {
    //'_id':'Lr7BmFtjWtWgXD28H'

    /*let users = Meteor.users.find({ 'profile.finishedRegister': true,'profile.tags.0': {
            '$in': ['texelfunding', 'texelpolis']
        }}).fetch()*/
    var users = Meteor.users.find({
      'profile.finishedRegister': true,
      'profile.data.createdAt': {
        $ne: null,
        $exists: true
      }
    }).fetch(); //console.log('users',users)

    var userCount = users.length;
    console.log('total users: ', userCount); // let totalMin = 0

    var c_10 = 0;
    var c_15 = 0;
    var c_20 = 0;
    var c_25 = 0; //  console.log(typeof (users))

    users.forEach(function (user) {
      var level5 = Measures.findOne({
        'createdBy': user._id,
        level: 5
      });
      var start = user.createdAt; //let end  = level5.dateCreated

      var end = user.profile.data.createdAt; // console.log('s: ',start)
      // console.log('e: ',end)

      var diff = diffMinutes(start, end);

      if (diff <= 10) {
        c_10++;
      } else if (diff <= 15) {
        c_15++;
      } else if (diff <= 20) {
        c_20++;
      } else if (diff <= 25) {
        c_25++;
      }
    });
    console.log('c_10: ', c_10);
    console.log('c_15: ', c_15);
    console.log('c_20: ', c_20);
    console.log('c_25: ', c_25);
  },
  _update: function _update() {
    console.log('CALLED: _update'); // ADD texel sub to users with texel tags

    var usersNoSubs = ['w5i38uEqHcSz696aj', 'nDbXv7C5qHwdkQQYH', 'Bno9zNDr6ohZPELk7', 'HbBgHGkFGMHps25x4', '66KH4Zwy5gBoSo8QL'];
    usersNoSubs.forEach(function (userId) {
      var user = Meteor.users.findOne({
        _id: userId
      }); // console.log(user.profile.email)

      Meteor.users.update({
        _id: userId
      }, {
        $addToSet: {
          'profile.subs': 'd4398724-1390-4ab1-bb3a-fa227340927c'
        }
      });
    });
    var users = Meteor.users.find({
      'profile.tags.0': {
        '$in': ['texelfunding', 'texelpolis']
      }
    }).fetch();
    console.log(users.length + ': TOTAL USERS'); // ADD patch tag for users with texel tags that have finsihed register but have no funding
    //

    console.log('117: group 1 START');
    var group1_count = 0;
    var group2_count = 0;
    var group3_count = 0;
    users.forEach(function (user) {
      var tagsOldValue = user.profile.tags_old || user.profile.tags;

      if (user.profile.finishedRegister && !user.profile.funding) {
        group1_count++;
        Meteor.users.update({
          _id: user._id
        }, {
          $set: {
            'profile.tags_old': tagsOldValue,
            'profile.tags': ['texelfunding'],
            'profile.group': 1
          }
        });
      }
    });
    console.log(group1_count + ': group 1 END');
    console.log('249: group 2 START');
    users.forEach(function (user) {
      var tagsOldValue = user.profile.tags_old || user.profile.tags;

      if (!user.profile.finishedRegister && !user.profile.funding) {
        group2_count++;
        var areas = Measures.find({
          'createdBy': user._id
        }).fetch();
        areas.forEach(function (area) {
          //console.log(area.id)
          Measures.remove(area._id);
        });
        Meteor.users.update({
          _id: user._id
        }, {
          $set: {
            'profile.tags_old': tagsOldValue,
            'profile.tags': ['texelfunding'],
            'profile.group': 2
          }
        });
      }
    });
    console.log(group2_count + ': group 2 END ');
    console.log('48: group 3 START ');
    users.forEach(function (user) {
      var tagsOldValue = user.profile.tags_old || user.profile.tags;

      if (user.profile.finishedRegister && user.profile.funding) {
        group3_count++;
        Meteor.users.update({
          _id: user._id
        }, {
          $set: {
            'profile.tags_old': tagsOldValue,
            'profile.tags': ['texelfunding'],
            'profile.group': 3
          }
        });
      }
    });
    console.log(group3_count + ': END group 3');
    console.log(group3_count + group1_count + group2_count + ': groups all ADDED');

    var sleep = function sleep(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    };

    function processUsers(_x) {
      return _processUsers.apply(this, arguments);
    } // Call the function


    function _processUsers() {
      _processUsers = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(users) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, user, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 3;
                _iterator = users[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 15;
                  break;
                }

                user = _step.value;
                console.log(user.profile.email);
                data = {
                  'attributes': {
                    'USERNAME': user.profile.name,
                    'REGISTERED': true,
                    'FINISHED_REGISTER': !!user.profile.finishedRegister,
                    'FINISHED_FUNDING': false,
                    'EXT_ID': user._id,
                    'GROUP': user.profile.group,
                    'ORIGIN': user.profile.tags_old,
                    'LOCALE': user.profile.locale
                  },
                  'email': user.profile.email,
                  updateEnabled: true
                }; // Run your Meteor logic

                Meteor.call('createUpdateContact', data); // Wait 2 seconds before the next iteration

                _context.next = 12;
                return sleep(2000);

              case 12:
                _iteratorNormalCompletion = true;
                _context.next = 5;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 17, 21, 29], [22,, 24, 28]]);
      }));
      return _processUsers.apply(this, arguments);
    }

    processUsers(users);
    /*users.forEach(user => {
        // if(user.profile.email === 'Lantink@t-online.de') {
        console.log(user.profile.email)
        let data = { // Use the 'data' key for the message body
            'attributes': {
                'USERNAME': user.profile.name,
                'REGISTERED': true,
                'FINISHED_REGISTER': user.profile.finishedRegister ? true : false,
                'FINISHED_FUNDING': false,
                'EXT_ID': user._id,
                'GROUP': user.profile.group,
                'ORIGIN': user.profile.tags_old,
                'LOCALE': user.profile.locale,
            },
            'email': user.profile.email,
            updateEnabled: true
        }
         // Meteor.setTimeout(() => {
        //     console.log('This runs after 2 seconds');
        //     Meteor.call('createUpdateContact', data);
        // }, 2000);
         // console.log('data', data)
        // setTimeout(Meteor.bindEnvironment(() => {
        //     console.log('This runs after 2 seconds')
        //     Meteor.call('createUpdateContact', data)
        // }), 2000)
         // }
     })*/
    // ADD patch tag for users with texel tags that have NOT finsihed register
    // let users2 = Meteor.users.find({
    //     'profile.tags.0': {
    //         '$in': ['texelfunding', 'texelpolis']
    //         //"$in": [ "texelpolis"]
    //     }
    // }).fetch()

    /*let users2 = Meteor.users.find({
        'profile.email': 'dobbel01@gmail.com'
    }).fetch()
     console.log('users2: ' + users2.length)
    var count = 0
    users2.forEach(user => {
        if (!user.profile.finishedRegister && !user.profile.funding) {
            // if (true) {
            console.log(user.profile.locale + ' ' + user.profile.tags + ' ' + user.profile.email)
            count++
             console.log(user.profile.tags + ' ' + user.profile.email)
               const tagsOldValue = user.profile.tags_old || user.profile.tags
            Meteor.users.update({
                    _id: user._id
                },
                {
                    $set: {
                        'profile.patches': ['texel-continue-register'],
                        'profile.tags_old': tagsOldValue,
                        'profile.tags': ['texelfunding']
                    }
                }
            )
             let data = { // Use the 'data' key for the message body
                'attributes': {
                    'USERNAME': user.profile.name,
                    'REGISTERED': true,
                    'FINISHED_REGISTER': user.profile.finishedRegister ,
                    'FINISHED_FUNDING': false,
                    'EXT_ID': user._id,
                    'GROUP': user.profile.group,
                    'ORIGIN': user.profile.tags_old,
                    'LOCALE': user.profile.locale,
                },
                'email': user.profile.email,
                updateEnabled: true
            }
             console.log('data', data)
             Meteor.call('createUpdateContact', data)
             /!*
            let areas = Measures.find({ 'createdBy': user._id }).fetch()
            areas.forEach(area => {
                Measures.remove(area._id)
            })*!/
            /!*Meteor.users.update({
                    _id: user._id
                },
                {
                    $set: {
                        'profile.patches': ['texel-continue-register'],
                        'profile.tags_old': user.profile.tags,
                        'profile.tags': ['texelfunding']
                    }
                }
            )*!/
        }
    })
    console.log('count ' + count)*/

    /*// Add score KV pairs
    let kv
    let _id
    kv = {
        type: 'VALUE',
        group: 'SCORE',
        key: 'DRAW_AREA',
        description: 'amount score will increase after drawing an area',
        id: genUuid(),
        value: 5
    }
    _id = KV.insert(kv)
     kv = {
        type: 'VALUE',
        group: 'SCORE',
        key: 'ADD_VIRTUAL_FUNDING',
        description: 'amount score will increase after adding virtual funding',
        id: genUuid(),
        value: 20
    }
    _id = KV.insert(kv)
     kv = {
        type: 'VALUE',
        group: 'SCORE',
        key: 'ADD_DISCUSSION_COMMENT',
        description: 'amount score will increase after adding reacting to a discussion (posting a message)',
        id: genUuid(),
        value: 1
    }
    _id = KV.insert(kv)
     kv = {
        type: 'VALUE',
        group: 'SCORE',
        key: 'FUND_PLEDGE',
        description: 'amount score will increase after funding a pledge',
        id: genUuid(),
        value: 10
    }
    _id = KV.insert(kv)*/

    console.log('\x1b[32m%s\x1b[0m', 'UPDATE method called');
    return {
      status: 200,
      message: 'this is a server response :)'
    };
  },
  _update_locale: function _update_locale() {
    console.log('\x1b[32m%s\x1b[0m', '_update_locale: method called');
    var landSet = new Set();
    var landMap = new Map();
    var users = Meteor.users.find({
      'profile.owner': null
    });
    console.log('setting FAN locale');
    users.forEach(function (user) {
      /*if(!user.profile.place) {
          console.log(user._id)
      }*/
      //console.log(user.profile.place.address_components.length)
      user.profile.place.address_components.forEach(function (comp) {
        comp.types.forEach(function (type) {
          // console.log(type)
          if (type === 'country') {
            var locale = 'en-us';

            if (comp.short_name === 'NL') {
              locale = 'nl-nl';
            } else if (comp.short_name === 'DE') {
              locale = 'de-de';
            }

            Meteor.users.update({
              _id: user._id
            }, {
              // $push: { 'profile.subs': intersectLand.id }
              $set: {
                'profile.locale': locale
              }
            }); //console.log('set: ',user._id +"->"+comp.short_name+" -> "+locale)

            /*landSet.add(comp.short_name)
            landMap.set(comp.short_name, (landMap.get(comp.short_name) || 0) + 1);*/
            //console.log(comp.short_name)
          }
        });
      });
    });
    console.log('setting  OWNER locale to \'en-us\'');
    var owners = Meteor.users.find({
      'profile.owner': true
    });
    owners.forEach(function (user) {
      Meteor.users.update({
        _id: user._id
      }, {
        // $push: { 'profile.subs': intersectLand.id }
        $set: {
          'profile.locale': 'en-us'
        }
      });
    });
    /*for (const [key, value] of landMap.entries()) {
        if(value > 1) {
            console.log(`${key}: ${value}`);
        }
    }*/
    //  console.log(landMap)

    /*landMap.forEach(key,value => {
        console.log(value);
    });*/

    /*landMap.forEach(value => {
        console.log(value);
    });*/

    console.log('DONE set_locale');
    return {
      status: 200,
      message: 'this is a server response :)'
    };
  },
  _test: function _test() {
    console.log('\x1b[32m%s\x1b[0m', 'TEST method called');
    return {
      status: 200,
      message: 'this is a server response :)'
    };
  },
  _logs: function _logs() {
    var logs = Logs.find().fetch();
    return {
      status: 200,
      message: 'this is a server response :)'
    };
  },
  _intersectAreas: function _intersectAreas(coords) {
    console.log(coords);
    var intersectLands = Measures.find({
      geometry: {
        $geoIntersects: {
          $geometry: {
            type: 'Polygon',
            coordinates: [[[6.313796, 53.429174], [6.314392, 53.31939], [6.127625, 53.311186], [6.141357, 53.429174], [6.313796, 53.429174]]] //coordinates: coords
            // [ [ 1.313796, 1.429174 ], [ 1.314392, 1.31939 ], [ 1.127625, 1.311186 ], [ 1.141357, 1.429174 ], [ 1.313796, 1.429174 ] ]

          }
        }
      }
    }).fetch(); // let intersectLands = result.

    /*intersectLands.forEach((land) => {
        console.log("A")
        console.log(land.id)
    })*/
    // console.log('\x1b[32m%s\x1b[0m', 'TEST method called')

    console.log('\x1b[32m%s\x1b[0m', intersectLands);
    return {
      status: 200,
      //message: 'this is a server response :)'
      message: intersectLands
    };
  },
  'logs.insert': function logsInsert(type, session, data) {
    var order = Logs.find({
      'session': session
    }).count() + 1; // let count = Measures.find({ 'createdBy': Meteor.userId() }).count() + 1
    // data = data ? data : 'LEVEL_' + count

    var alog = {
      order: order,
      session: session,
      type: type,
      user: Meteor.userId(),
      createdAt: new Date(),
      data: data ? data : undefined
    };

    var _id = Logs.insert(alog);
  },
  'tasks.insert': function tasksInsert(title) {
    check(title, String);
    Tasks.insert({
      title: title,
      createdAt: new Date()
    });
  },
  'tasks.update': function tasksUpdate(taskId, task) {
    check(taskId, String);
    check(task, String);
    Tasks.update(taskId, {
      $set: {
        _id: taskId,
        updatedAt: new Date(),
        title: task
      }
    });
  },
  'tasks.remove': function tasksRemove(taskId) {
    check(taskId, String);
    Tasks.remove(taskId);
  },
  'polygon.insert': function polygonInsert(polygon) {
    /* console.log('\x1b[32m%s\x1b[0m', 'CREATED Marker [id:'+id+', userid:'+measure.properties.userid+']'); */
    console.log('\x1b[32m%s\x1b[0m', 'Polygon insert');
    polygon.dateCreated = new Date();
    polygon.createdBy = Meteor.userId();
    var id = Polygons.insert(polygon);
    console.log('\x1b[32m%s\x1b[0m', 'CREATED Polygon ' + id); // console.log('\x1b[32m%s\x1b[0m', 'CREATED Marker [id:'+id+', userid:'+marker.properties.userid+']');

    /* return {
      id      : id,
      status  : 201,
      message : "Marker:["+id+"] is successfully created"
    }; */
  },
  'land.insert': function landInsert(measure, data, analitics) {
    console.log('\x1b[32m%s\x1b[0m', 'CALL: LAND.insert START');
    delete measure['properties'];

    var area = _objectSpread({}, measure, {}, data, {}, analitics);

    area.dateCreated = data.dateCreated ? data.dateCreated : new Date();
    area.createdBy = Meteor.userId();
    area.mods = [Meteor.userId()];
    area.modrequests = [];
    area.organization = Meteor.user().profile.organization; // area.owner = Meteor.userId()

    area.threads = [];
    area.polls = [];
    area.polis = [];
    area.pledges = [];
    area.meetings = [];
    area.treasures = [];
    area.messages = [];

    try {
      var intersectMeasures = Measures.find({
        geometry: {
          $geoIntersects: {
            $geometry: {
              type: 'Polygon',
              coordinates: area.geometry.coordinates // [ [ 1.313796, 1.429174 ], [ 1.314392, 1.31939 ], [ 1.127625, 1.311186 ], [ 1.141357, 1.429174 ], [ 1.313796, 1.429174 ] ]
              //[ [ 6.313796, 53.429174 ], [ 6.314392, 53.31939 ], [ 6.127625, 53.311186 ], [ 6.141357, 53.429174 ], [ 6.313796, 53.429174 ] ]

            }
          }
        }
      }); // console.log("intersectMeasures",intersectMeasures)

      intersectMeasures.forEach(function (measure) {
        /*console.log("measure id",measure._id)
        console.log("measure createdBy",measure.createdBy)*/
        var user = Meteor.users.findOne({
          _id: measure.createdBy
        });
        /*console.log("user",user)
        console.log("user id",user._id)
        console.log("user name",user.name)*/

        Meteor.users.update({
          _id: user._id
        }, {
          // $push: { 'profile.subs': intersectLand.id }
          $push: {
            'profile.subs': area.id
          }
        });
      });
    } catch (e) {
      console.log(e);
    }

    var _id = Land.insert(area);

    console.log('\x1b[32m%s\x1b[0m', 'CREATED LAND ' + _id);
    console.log('\x1b[32m%s\x1b[0m', 'CALL: LAND.insert END');
  },
  'measure.insert': function measureInsert(measure, data, analitics) {
    /* console.log('\x1b[32m%s\x1b[0m', 'CREATED Marker [id:'+id+', userid:'+measure.properties.userid+']'); */
    console.log('\x1b[32m%s\x1b[0m', 'CALL: measure.insert START'); // console.log('measure', measure)
    // console.log('data', data)
    // console.log('user', Meteor.userId() + Meteor.user().emails)
    // console.log('email', Meteor.user().emails)

    delete measure['properties'];

    var area = _objectSpread({}, measure, {}, data, {}, analitics); // console.log('measure', area)
    // console.log('measure', area.geometry.coordinates)


    area.dateCreated = data.dateCreated ? data.dateCreated : new Date();
    area.createdBy = data.createdBy ? data.createdBy : Meteor.userId();
    /*// UUID
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'
     var uuid = s.join('')*/

    area.id = genUuid();

    var _id = Measures.insert(area);

    if (Meteor.user().profile.finishedRegister !== true) {
      var measures = Measures.find({
        'createdBy': Meteor.userId()
      }, {
        sort: {
          dateCreated: -1
        }
      }).fetch();

      if (measures && measures.length === 4) {
        Meteor.users.update({
          _id: Meteor.userId()
        }, {
          // $push: { 'profile.subs': intersectLand.id }
          $set: {
            'profile.finishedRegister': true
          }
        });
        var _data = {
          'attributes': {
            'FINISHED_REGISTER': true
          },
          'email': Meteor.user().profile.email,
          updateEnabled: true
        }; // console.log('data2',data)

        Meteor.call('createUpdateContact', _data);
      }
    } //Update score


    var amountInc = KV.findOne({
      'key': 'DRAW_AREA'
    }).value;
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $inc: {
        'profile.score': amountInc
      }
    }); // area.analitics = analitics
    // Meteor._sleepForMs(3000)
    // INTERSECT for subs

    /*let intersectLands = Land.find(
        {
            geometry: {
                $geoIntersects: {
                    $geometry: {
                        type: 'Polygon',
                        coordinates: area.geometry.coordinates
                        // [ [ 1.313796, 1.429174 ], [ 1.314392, 1.31939 ], [ 1.127625, 1.311186 ], [ 1.141357, 1.429174 ], [ 1.313796, 1.429174 ] ]
                        //[ [ 6.313796, 53.429174 ], [ 6.314392, 53.31939 ], [ 6.127625, 53.311186 ], [ 6.141357, 53.429174 ], [ 6.313796, 53.429174 ] ]
                     }
                }
            }
        }
    )*/

    try {
      var intersectLands = Land.find({
        geometry: {
          $geoIntersects: {
            $geometry: area.geometry
          }
        }
      });
      intersectLands.forEach(function (land) {
        if (!land.system) {
          Meteor.users.update({
            _id: Meteor.userId()
          }, {
            // $push: { 'profile.subs': intersectLand.id }
            $push: {
              'profile.subs': land.id
            },
            $inc: {
              'profile.score': 5
            }
          });
        }
      });
    } catch (e) {
      console.log(e);
    }

    console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');
    console.log('\x1b[32m%s\x1b[0m', 'CREATED Measure ' + _id);
    console.log('\x1b[32m%s\x1b[0m', 'CALL: measure.insert END');
  },
  'measure.delete': function measureDelete(measureId) {
    console.log('CALL: measure.delete START', measureId);
    var measure = Measures.findOne({
      '_id': measureId
    });

    if (measure.createdBy === Meteor.userId()) {
      Measures.remove(measureId);
      /*Meteor.users.update({ _id: Meteor.userId() }, {
          $inc: { 'profile.score': -1 }
      })*/
    } else {
      throw new Meteor.Error('not allowed', 'Cannot delete measure');
    }

    console.log('measure.delete END', measureId);
  },
  'measure.update': function measureUpdate(measureId, data) {
    console.log('CALL: measure.update START', measureId); // console.log('measureId', measureId)

    console.log('data', data);
    console.log('data...', data); // console.log('user', Meteor.userId() + Meteor.user().emails)
    // console.log('email', Meteor.user().emails)

    var measure = Measures.findOne({
      '_id': measureId
    }); // console.log('measure', measure)
    // check(title, String)
    // check(description, String)

    if (measure.createdBy === Meteor.userId()) {
      console.log('-----------ok---------------');
      var result = Measures.update(measureId, {
        $set: _objectSpread({
          updatedAt: new Date()
        }, data)
      });
      console.log('-----------result-----------', result);
    }

    measure = Measures.findOne({
      '_id': measureId
    });
    console.log('measure UPDATED', measure);
    console.log('measure.update END', measureId);
  },
  'editCommunity': function editCommunity(id, title, description) {
    console.log('CALL: community.update START', id);
    var land = Land.findOne({
      '_id': id
    }); // console.log('measure', measure)
    // check(title, String)
    // check(description, String)

    console.log('-----------ok---------------');
    var result = Land.update(id, {
      $set: {
        title: title,
        description: description
      }
    });
    console.log('-----------result-----------', result); // measure = Measures.findOne({ '_id': measureId })

    /*        console.log('land UPDATED', measure)
             console.log('land.edit END', measureId)*/
  },
  'deleteCommunity': function deleteCommunity(communityId) {
    var land = Land.findOne({
      '_id': communityId
    }); // let meeting = land.meetings.filter(item => item.id === meetingId)[0]
    // console.log(land.meetings)
    // console.log('-----------xx---gg------yy')
    // land.meetings.remove(meeting)
    // console.log(land.meetings)

    Land.remove({
      '_id': communityId
    } // {
    //     $set: {
    //         'meetings': land.meetings
    //     }
    // }
    );
  },
  'register.saveFunding': function registerSaveFunding(data) {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        'profile.amount': Number(data.amount),
        'profile.reason': data.reason
      }
    });
  },
  'register.pauze': function registerPauze() {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        'profile.register_pauzed': true
      }
    });
  },
  'pbl.saveQ2': function pblSaveQ2(data) {
    data.createdAt = new Date();
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        'profile.data': data
      }
    });
  },
  'pbl.saveEmail': function pblSaveEmail(email) {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        'profile.exEmail': email
      }
    });
  },
  'pbl.saveFeedback': function pblSaveFeedback(feedback) {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        'profile.updatedAt': new Date(),
        'profile.feedback': feedback
      }
    });
  },
  'addFunding': function addFunding(obj) {
    obj.createdAt = new Date();
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $push: {
        'profile.funding': obj
      }
    });
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        'profile.amount': Number(obj.amount),
        'profile.reason': obj.reason
      }
    }); //Update score

    var amountInc = KV.findOne({
      'key': 'ADD_VIRTUAL_FUNDING'
    }).value;
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $inc: {
        'profile.score': amountInc
      }
    });

    if (Meteor.user().profile.finishedFunding !== true) {
      Meteor.users.update({
        _id: Meteor.userId()
      }, {
        // $push: { 'profile.subs': intersectLand.id }
        $set: {
          'profile.finishedFunding': true
        }
      });
      var data = {
        'attributes': {
          'FINISHED_FUNDING': true
        },
        'email': Meteor.user().profile.email,
        updateEnabled: true
      }; // console.log('data2',data)

      Meteor.call('createUpdateContact', data);
    }
  },
  'unsubscribe': function unsubscribe(landId) {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $pull: {
        'profile.subs': landId
      }
    });
  },
  'subscribe': function subscribe(landId) {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $addToSet: {
        'profile.subs': landId
      }
    });
  },
  'addModeratorRequest': function addModeratorRequest(communityId) {
    Land.update({
      id: communityId
    }, {
      $addToSet: {
        'modrequests': Meteor.userId()
      }
    });
  },
  'removeModeratorRequest': function removeModeratorRequest(userId, communityId) {
    Land.update({
      id: communityId
    }, {
      $pull: {
        'modrequests': userId
      }
    });
  },
  'addModerator': function addModerator(userId, communityId) {
    Land.update({
      id: communityId
    }, {
      $pull: {
        'modrequests': userId
      }
    }, {
      $addToSet: {
        'mods': userId
      }
    });
    Land.update({
      id: communityId
    }, {
      $addToSet: {
        'mods': userId
      }
    });
  },
  'addThread': function addThread(communityId, title, description, base64Images) {
    console.log('base64Images', base64Images); // console.log("base64Image")
    // //console.log(base64Image)
    // // UUID
    // var s = []
    // var hexDigits = '0123456789abcdef'
    // for (var i = 0; i < 36; i++) {
    //     s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    // }
    // s[14] = '4'  // bits 12-15 of the time_hi_and_version field to 0010
    // s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    // s[8] = s[13] = s[18] = s[23] = '-'
    //
    // var uuid = s.join('')

    var threadUUID = genUuid();
    var imageUuids = [];
    base64Images.forEach(function (base64Image) {
      var uuid = genUuid();
      imageUuids.push(uuid);
      Meteor.call('uploadImageFileBase64', base64Image, threadUUID, uuid);
    }); //console.log('base64Images',base64Images)
    // const imageName = Meteor.call('uploadImageFileBase64', base64Image, '112233')

    Land.update({
      id: communityId
    }, {
      $push: {
        'threads': {
          id: threadUUID,
          title: title,
          description: description,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          comments: [],
          images: imageUuids
        }
      }
    });
  },
  'editThread': function editThread(id, communityId, title, description, base64Images) {
    // //console.log(base64Image)
    // // UUID
    // var s = []
    // var hexDigits = '0123456789abcdef'
    // for (var i = 0; i < 36; i++) {
    //     s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    // }
    // s[14] = '4'  // bits 12-15 of the time_hi_and_version field to 0010
    // s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    // s[8] = s[13] = s[18] = s[23] = '-'
    //
    // var uuid = s.join('')
    //let threadUUID =  genUuid()
    var imageUuids = [];
    base64Images.forEach(function (base64Image) {
      var uuid = genUuid();
      imageUuids.push(uuid);
      Meteor.call('uploadImageFileBase64', base64Image, id, uuid);
    }); //console.log('base64Images',base64Images)
    // const imageName = Meteor.call('uploadImageFileBase64', base64Image, '112233')

    Land.update({
      'threads.id': id // id: communityId

    }, {
      $set: {
        'threads.$.title': title,
        'threads.$.description': description,
        'threads.$.images': imageUuids,
        'threads.$.updatedAt': new Date()
      } // $push: {
      //     'threads': {
      //         id: threadUUID,
      //         title: title,
      //         description: description,
      //         createdBy: Meteor.userId(),
      //         createdByName: Meteor.user().profile.name,
      //         createdAt: new Date(),
      //         comments: [],
      //         images: imageUuids
      //     }
      // }

    });
  },
  'deleteThread': function deleteThread(threadId) {
    var land = Land.findOne({
      'threads.id': threadId
    });
    var thread = land.threads.filter(function (item) {
      return item.id === threadId;
    })[0];
    console.log(land.threads);
    console.log('-----------xx---gg------yy');
    land.threads.remove(thread);
    console.log(land.threads);
    Land.update({
      'id': land.id
    }, {
      $set: {
        'threads': land.threads
      }
    });
  },
  'addMeeting': function addMeeting(communityId, title, description, url, startTime) {
    // UUID
    var s = [];
    var hexDigits = '0123456789abcdef';

    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }

    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010

    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    Land.update({
      id: communityId
    }, {
      $push: {
        'meetings': {
          id: uuid,
          title: title,
          description: description,
          link: 'https://' + url,
          startTime: startTime,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          linkSent: false,
          accepted: [],
          rejected: []
        }
      }
    });
    var community = Land.findOne({
      'id': communityId
    }); //console.log("community",community)

    var users = Meteor.users.find(); //console.log('users', users)

    var newUrl = Meteor.settings.public.serverUrl + '/meeting/' + uuid;
    users.forEach(function (user) {
      if (user.profile.subs.includes(community.id)) {
        //console.log('send invite to: ' + user.profile.email)
        var template = KV.findOne({
          'key': 'MEETING_INVITED'
        });
        var body = template.value.body; //  console.log("BODY",body)

        body = template.value.body.replace('$USERNAME', user.profile.name);
        body = replaceAll(body, '$URL', newUrl);
        body = replaceAll(body, '$COMMUNITY_NAME', community.title);
        /*                var str = 'Hi Friends user ' + user.profile.name + '\n\n'
                        str += 'You have been invited to an online meeting by the ' + community.title + ' community' + '\n\n'
                        str += 'The details about this meeting can be found below. Please note that in some cases the number of people wanting to join can be too big. In that case we will make a random selection from the people that shows interest in the meeting. For that reason we ask you to either Accept or Decline the invitation.' + '\n\n'
                        str += newUrl*/

        Meteor.call('sendHtmlEmail', //user.profile.email,
        'greenmapper@mail4qa.com', 'friends@greenmapper.org', template.value.title, body); // }
      }
    });
  },
  'deleteMeeting': function deleteMeeting(meetingId) {
    var land = Land.findOne({
      'meetings.id': meetingId
    });
    var meeting = land.meetings.filter(function (item) {
      return item.id === meetingId;
    })[0];
    land.meetings.remove(meeting);
    Land.update({
      'id': land.id
    }, {
      $set: {
        'meetings': land.meetings
      }
    });
  },

  /*    'sendFundingInvites' (communityId) {
          let land = Land.findOne({ 'id': communityId })
           let users = Meteor.users.find({}).fetch()
           users.forEach(user => {
              if (!user.profile.funding && user.profile.subs.includes(communityId)) {
                   const newUrl = Meteor.settings.public.serverUrl + '/survey/funding'
                   var str = 'Hi user ' + user.profile.name + '\n\n'
                  str += 'You have been selected to join the online funding survey' + '\n\n'
                  str += 'Go to link to take part in the survey:' + '\n\n'
                  str += newUrl + '\n\n'
                   Meteor.call(
                      'sendEmail',
                      user.profile.email,
                      //'greenmapper@mail4qa.com',
                      'friends@greenmapper.org',
                      'Greenmapper: Link for funding survey',
                      str
                  )
               }
          })
       },*/
  'sendInvites': function sendInvites(communityId, meetingId, link, startTime, number) {
    console.log('CALLED: sendInvites');
    var land = Land.findOne({
      'meetings.id': meetingId
    });
    var meeting = land.meetings.filter(function (item) {
      return item.id === meetingId;
    })[0];
    meeting.linkSent = true;
    meeting.startTime = startTime;
    meeting.number = number;
    meeting.link = link;
    var users = Meteor.users.find({
      '_id': {
        '$in': meeting.accepted
      }
    }).fetch();
    users.shuffle();
    var users2 = users.slice(0, number);
    users2.forEach(function (user) {
      // console.log(user.profile.email)
      var template = KV.findOne({
        'key': 'MEETING_SELECTED'
      });
      var body = template.value.body;
      body = template.value.body.replace('$USERNAME', user.profile.name);
      body = replaceAll(body, '$URL', 'https://' + meeting.link);
      body = replaceAll(body, '$COMMUNITY_NAME', land.title);
      body = replaceAll(body, '$START_TIME', startTime);
      body = replaceAll(body, '$MEETING_TITLE', meeting.title);
      body = replaceAll(body, '$MEETING_DESCRIPTION', meeting.description); // params: ['$USERNAME','$URL','$COMMUNITY_NAME','$START_TIME','$MEETING_TITLE','$COMMUNITY_NAME']

      /*            var str = 'Hi user ' + user.profile.name + '\n\n'
                  str += 'You have been selected to join the online meeting! We want to thank you for showing interest and look forward to meeting with you.' + '\n\n'
                  str += 'Go to link to join the meeting:' + meeting.link + '\n\n'
                  str += meeting.link + '\n\n'
                  str += 'Time of meeting: ' + meeting.startTime + '\n\n'
                  str += 'Title of meeting: ' + meeting.title + '\n\n'
                  str += 'Description of meeting: ' + meeting.description + '\n\n'
                  str += 'Name of community: ' + land.title + '\n\n'*/

      Meteor.call('sendHtmlEmail', //user.profile.email,
      'greenmapper@mail4qa.com', 'friends@greenmapper.org', template.value.title, body);
    });
    Land.update({
      'meetings.id': meetingId
    }, {
      // $addToSet: { 'threads.$.meetings': userId }
      $set: {
        'meetings': land.meetings
      }
    });
  },
  'acceptInvite': function acceptInvite(meetingId) {
    var land = Land.findOne({
      'meetings.id': meetingId
    });
    var meeting = land.meetings.filter(function (item) {
      return item.id === meetingId;
    })[0];
    meeting.accepted.push(Meteor.userId());
    Land.update({
      'meetings.id': meetingId
    }, {
      // $addToSet: { 'threads.$.meetings': userId }
      $set: {
        'meetings': land.meetings
      }
    });
  },
  'rejectInvite': function rejectInvite(meetingId) {
    var land = Land.findOne({
      'meetings.id': meetingId
    });
    var meeting = land.meetings.filter(function (item) {
      return item.id === meetingId;
    })[0];
    meeting.rejected.push(Meteor.userId());
    Land.update({
      'meetings.id': meetingId
    }, {
      // $addToSet: { 'threads.$.meetings': userId }
      $set: {
        'meetings': land.meetings
      }
    });
  },
  'isRead': function isRead(messageId) {
    var land = Land.findOne({
      'messages.id': messageId
    });
    var message = land.messages.filter(function (item) {
      return item.id === messageId;
    })[0];

    if (message.rcc.indexOf(Meteor.userId()) === -1) {
      message.rcc.push(Meteor.userId());
    }

    Land.update({
      '_id': land._id
    }, {
      // $addToSet: { 'threads.$.meetings': userId }
      $set: {
        'messages': land.messages
      }
    });
  },
  'addMessage': function addMessage(communityId, data) {
    var uuid = genUuid();
    var cc = [];
    var users = [];
    var community = Land.findOne({
      'id': communityId
    });
    Meteor.users.find({}).forEach(function (user) {
      if (community.system || !user.profile.owner && user.profile.subs && user.profile.subs.includes(communityId)) {
        cc.push(user._id);
        users.push(user);
      }
    });
    Land.update({
      id: communityId
    }, {
      $push: {
        'messages': {
          id: uuid,
          title: data.title,
          body: data.body,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          from: community.title,
          fromId: community.id,
          cc: cc,
          rcc: [],
          system: community.system
        }
      }
    });
    var count = 0;
    users.forEach(function (user) {
      // console.log(user.profile.email)
      // Client: Asynchronously send an email.
      // if (user.profile.email === 'dobbel01@hotmail.com') {
      var link = Meteor.settings.public.serverUrl + '/inbox'; //let link = 'https://friends.greenmapper.org/inbox'

      var template = KV.findOne({
        'key': 'COMMUNITY_MESSAGE'
      });
      var body = template.value.body;
      body = template.value.body.replace('$USERNAME', user.profile.name);
      body = replaceAll(body, '$URL', link);
      body = replaceAll(body, '$COMMUNITY_NAME', community.title);
      body = replaceAll(body, '$MESSAGE_TITLE', data.title);
      /*var str = 'Hi user ' + user.profile.name + ',\n\n'
      str += 'There is a new message from the \'' + community.title + '\' community' + '\n\n'
      // str += 'from: ' + community.title+ '\n\n'
      // str +=  community.title+ ':\n'
      str += '"' + data.title + '"' + '\n\n'
      str += 'Go to this link to see the message:' + '\n\n'
      str += link + '\n\n'
      str += 'Greetings from the Greenmapper Friends team' + '\n\n'*/
      // str +=  link
      //greenmapper@mail4qa.com

      if (count === 0) {
        Meteor.call('sendHtmlEmail', 'greenmapper@mail4qa.com', 'friends@greenmapper.org', template.value.title, body);
        count++;
      }
    });
  },
  'mailer': function mailer(data) {
    console.log('CALLED: Mailer');

    if (data.testEmail) {
      var body = data.body.replace('$USERNAME', 'John Doe');
      body = replaceAll(body, '$AUTO_LOGIN_URL_CONTINUE_REGISTER', 'https://friends.greenmapper.org/survey/texel-continue-register/' + '123');
      body = replaceAll(body, '$AUTO_LOGIN_URL_CONTINUE_FUNDING', 'https://friends.greenmapper.org/survey/texel-continue-virtual-funding/' + '1234');
      Meteor.call('sendHtmlEmail', data.testEmail, 'friends@greenmapper.org', data.title, body);
    } else {
      var users = [];
      data.userIds.forEach(function (id) {
        var aUser = Meteor.users.findOne({
          '_id': id
        });
        users.push(aUser);
      });
      var count = 0;
      users.forEach(function (user) {
        var body = data.body.replace('$USERNAME', user.profile.name);
        body = replaceAll(body, '$AUTO_LOGIN_URL_CONTINUE_REGISTER', 'https://friends.greenmapper.org/survey/texel-continue-register/' + user._id);
        body = replaceAll(body, '$AUTO_LOGIN_URL_CONTINUE_FUNDING', 'https://friends.greenmapper.org/survey/texel-continue-virtual-funding/' + user._id); //greenmapper@mail4qa.com

        if (count === 0) {
          Meteor.call('sendHtmlEmail', 'greenmapper@mail4qa.com', 'friends@greenmapper.org', data.title, body);
          count++;
        }
      });
    }
  },
  'addPolis': function addPolis(communityId, title, polisId, options) {
    // UUID
    var s = [];
    var hexDigits = '0123456789abcdef';

    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }

    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010

    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    Land.update({
      id: communityId
    }, {
      $push: {
        'polis': {
          id: uuid,
          title: title,
          polisId: polisId,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          options: options
        }
      }
    });
  },
  'deletePolis': function deletePolis(pollId) {
    var land = Land.findOne({
      'polis.id': pollId
    });
    var poll = land.polis.filter(function (item) {
      return item.id === pollId;
    })[0];
    console.log(land.polls);
    console.log('-----------xx---gg------yy');
    land.polis.remove(poll);
    console.log(land.polis);
    Land.update({
      'id': land.id
    }, {
      $set: {
        'polis': land.polis
      }
    });
  },
  'addPoll': function addPoll(communityId, title, description, polisId, options) {
    // UUID
    var s = [];
    var hexDigits = '0123456789abcdef';

    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }

    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010

    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    Land.update({
      id: communityId
    }, {
      $push: {
        'polls': {
          id: uuid,
          title: title,
          description: description,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          options: options
        }
      }
    });
  },
  'deletePoll': function deletePoll(pollId) {
    var land = Land.findOne({
      'polls.id': pollId
    });
    var poll = land.polls.filter(function (item) {
      return item.id === pollId;
    })[0];
    console.log(land.polls);
    console.log('-----------xx---gg------yy');
    land.polls.remove(poll);
    console.log(land.polls);
    Land.update({
      'id': land.id
    }, {
      $set: {
        'polls': land.polls
      }
    });
  },
  // 'addPledge' (communityId, title, description, goal) {
  'addPledge': function addPledge(communityId, data, base64Images) {
    var pledgeUUID = genUuid();
    var imageUuids = [];
    base64Images.forEach(function (base64Image) {
      var uuid = genUuid();
      imageUuids.push(uuid);
      Meteor.call('uploadImageFileBase64', base64Image, pledgeUUID, uuid);
    });
    Land.update({
      id: communityId
    }, {
      $push: {
        'pledges': {
          id: pledgeUUID,
          title: data.title,
          description: data.description,
          goal: Number(data.goal),
          amount: 0,
          number: 0,
          reasons: [],
          type: data.type,
          geometry: data.geometry,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          images: imageUuids,
          data: []
        }
      }
    });
  },
  'editPledge': function editPledge(id, communityId, data, base64Images) {
    //let pledgeUUID =  genUuid()
    var imageUuids = [];
    base64Images.forEach(function (base64Image) {
      var uuid = genUuid();
      imageUuids.push(uuid);
      Meteor.call('uploadImageFileBase64', base64Image, id, uuid);
    });
    Land.update({
      'pledges.id': id
    }, {
      '$set': {
        'pledges.$.title': data.title,
        'pledges.$.description': data.description,
        'pledges.$.images': imageUuids,
        'pledges.$.updatedAt': new Date(),
        'pledges.$.goal': Number(data.goal),
        'pledges.$.type': data.type,
        'pledges.$.geometry': data.geometry
      }
    });
  },
  'deletePledge': function deletePledge(pledgeId) {
    var land = Land.findOne({
      'pledges.id': pledgeId
    });
    var pledge = land.pledges.filter(function (item) {
      return item.id === pledgeId;
    })[0];
    console.log(land.pledges);
    console.log('-----------xx---gg------yy');
    land.pledges.remove(pledge);
    console.log(land.pledges);
    Land.update({
      'id': land.id
    }, {
      $set: {
        'pledges': land.pledges
      }
    });
  },
  'addTreasure': function addTreasure(communityId, data, base64Images) {
    var aUUID = genUuid();
    var imageUuids = [];
    base64Images.forEach(function (base64Image) {
      var uuid = genUuid();
      imageUuids.push(uuid);
      Meteor.call('uploadImageFileBase64', base64Image, aUUID, uuid);
    });
    Land.update({
      id: communityId
    }, {
      $push: {
        'treasures': {
          id: aUUID,
          title: data.title,
          description: data.description,
          geometry: data.geometry,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          image: imageUuids[0],
          flagged: false,
          report_text: ''
        }
      }
    });
  },
  'reportTreasure': function reportTreasure(treasureId, text) {
    var land = Land.findOne({
      'treasures.id': treasureId
    });
    var treasure = land.treasures.filter(function (item) {
      return item.id === treasureId;
    })[0];
    Land.update({
      'treasures.id': treasureId
    }, {
      $set: {
        'treasures.$.flagged': true,
        'treasures.$.report_text': treasure.report_text + '\n' + '-----------------------------' + '\n' + text // 'pledges.$.report_text': treasure.report_text + "\n"

      }
    });
    /*console.log("reportTreasure",communityId, treasureId, text)
    let land = Land.findOne({ 'id': communityId })
    let treasure = land.treasures.filter(item => item.id === treasureId)[0]
    //let comment = thread.comments.filter(item => item.id === commentId)[0]
    //comment.flagged = true
     Land.update({
            'id': communityId
        },
        {
            $set: {
                'threads.$.comments': thread.comments
            }
        }
    )*/
  },
  'unReportTreasure': function unReportTreasure(treasureId) {
    var land = Land.findOne({
      'treasures.id': treasureId
    });
    var treasure = land.treasures.filter(function (item) {
      return item.id === treasureId;
    })[0];
    Land.update({
      'treasures.id': treasureId
    }, {
      $set: {
        'treasures.$.flagged': false //'treasures.$.report_text': ''

      }
    });
  },
  'deleteTreasure': function deleteTreasure(treasureId) {
    var land = Land.findOne({
      'treasures.id': treasureId
    });
    var treasure = land.treasures.filter(function (item) {
      return item.id === treasureId;
    })[0];
    console.log(land.treasures);
    console.log('sdfgdffgds');
    land.treasures.remove(treasure);
    console.log(land.treasures);
    Land.update({
      'id': land.id
    }, {
      $set: {
        'treasures': land.treasures
      }
    });
  },
  'addAmountPledge': function addAmountPledge(pledgeId, amount, reason) {
    var land = Land.findOne({
      'pledges.id': pledgeId
    });
    Land.update({
      'pledges.id': pledgeId
    }, {
      $inc: {
        'pledges.$.amount': Number(amount),
        'pledges.$.number': 1
      }
    });
    Land.update({
      'pledges.id': pledgeId
    }, {
      $push: {
        'pledges.$.reasons': reason
      }
    });
    var record = {};
    record.id = genUuid();
    record.userid = Meteor.userId();
    record.amount = Number(amount);
    record.reason = reason;
    record.createdAt = new Date();
    Land.update({
      'pledges.id': pledgeId
    }, {
      $push: {
        'pledges.$.data': record
      }
    }); //Update score

    var amountInc = KV.findOne({
      'key': 'FUND_PLEDGE'
    }).value;
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $inc: {
        'profile.score': amountInc
      }
    });
  },
  'reportComment': function reportComment(commentId, threadId) {
    var land = Land.findOne({
      'threads.comments.id': commentId
    });
    var thread = land.threads.filter(function (item) {
      return item.id === threadId;
    })[0];
    var comment = thread.comments.filter(function (item) {
      return item.id === commentId;
    })[0];
    comment.flagged = true;
    Land.update({
      'threads.id': threadId
    }, {
      $set: {
        'threads.$.comments': thread.comments
      }
    });
  },
  'deleteComment': function deleteComment(commentId, threadId) {
    var land = Land.findOne({
      'threads.comments.id': commentId
    });
    var thread = land.threads.filter(function (item) {
      return item.id === threadId;
    })[0]; // let comment = thread.comments.filter( item => item.id === commentId)[0]

    var newComments = thread.comments.filter(function (item) {
      return item.id !== commentId;
    });
    Land.update({
      'threads.id': threadId
    }, {
      $set: {
        'threads.$.comments': newComments
      }
    });
  },
  'unReportComment': function unReportComment(commentId, threadId) {
    var land = Land.findOne({
      'threads.comments.id': commentId
    });
    var thread = land.threads.filter(function (item) {
      return item.id === threadId;
    })[0];
    var comment = thread.comments.filter(function (item) {
      return item.id === commentId;
    })[0];
    comment.flagged = false;
    Land.update({
      'threads.id': threadId
    }, {
      $set: {
        'threads.$.comments': thread.comments
      }
    });
  },
  'upVoteComment': function upVoteComment(commentId, threadId) {
    var land = Land.findOne({
      'threads.comments.id': commentId
    });
    var thread = land.threads.filter(function (item) {
      return item.id === threadId;
    })[0];
    var comment = thread.comments.filter(function (item) {
      return item.id === commentId;
    })[0];
    comment.upVotes.push(Meteor.userId());
    comment.downVotes.remove(Meteor.userId());
    Land.update({
      'threads.id': threadId
    }, {
      $set: {
        'threads.$.comments': thread.comments
      }
    });
  },
  'removeUpVoteComment': function removeUpVoteComment(commentId, threadId) {
    var land = Land.findOne({
      'threads.comments.id': commentId
    });
    var thread = land.threads.filter(function (item) {
      return item.id === threadId;
    })[0];
    var comment = thread.comments.filter(function (item) {
      return item.id === commentId;
    })[0];
    comment.upVotes.remove(Meteor.userId());
    Land.update({
      'threads.id': threadId
    }, {
      $set: {
        'threads.$.comments': thread.comments
      }
    });
  },
  'downVoteComment': function downVoteComment(commentId, threadId) {
    var land = Land.findOne({
      'threads.comments.id': commentId
    });
    var thread = land.threads.filter(function (item) {
      return item.id === threadId;
    })[0];
    var comment = thread.comments.filter(function (item) {
      return item.id === commentId;
    })[0];
    comment.downVotes.push(Meteor.userId());
    comment.upVotes.remove(Meteor.userId());
    Land.update({
      'threads.id': threadId
    }, {
      $set: {
        'threads.$.comments': thread.comments
      }
    });
  },
  'removeDownVoteComment': function removeDownVoteComment(commentId, threadId) {
    var land = Land.findOne({
      'threads.comments.id': commentId
    });
    var thread = land.threads.filter(function (item) {
      return item.id === threadId;
    })[0];
    var comment = thread.comments.filter(function (item) {
      return item.id === commentId;
    })[0];
    comment.downVotes.remove(Meteor.userId());
    Land.update({
      'threads.id': threadId
    }, {
      $set: {
        'threads.$.comments': thread.comments
      }
    });
  },
  'addComment': function addComment(threadId, comment) {
    // UUID
    var s = [];
    var hexDigits = '0123456789abcdef';

    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }

    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010

    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    Land.update({
      'threads.id': threadId
    }, {
      // $push : { threads: { [day]: { "$[index]": score } } }
      $push: {
        'threads.$.comments': {
          id: uuid,
          text: comment,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          upVotes: [],
          downVotes: []
        }
      } // $push: {
      //     'threads.${index}.comments': {
      //         id: uuid,
      //         text:comment,
      //         createdBy: Meteor.userId(),
      //         createdAt: new Date(),
      //     }
      // }

    } // { arrayFilters: [ { index: index } ] },
    ); //Update score

    var amountInc = KV.findOne({
      'key': 'ADD_DISCUSSION_COMMENT'
    }).value;
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $inc: {
        'profile.score': amountInc
      }
    });
  },
  'addVote': function addVote(pollId, value) {
    // UUID
    var s = [];
    var hexDigits = '0123456789abcdef';

    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }

    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010

    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    var land = Land.findOne({
      'polls.id': pollId
    });
    var poll = land.polls.filter(function (item) {
      return item.id === pollId;
    })[0];
    var option = poll.options.filter(function (item) {
      return item.value === value;
    })[0];
    option.votes.push({
      id: uuid,
      value: value,
      createdBy: Meteor.userId(),
      createdByName: Meteor.user().profile.name,
      createdAt: new Date()
    });
    Land.update({
      'polls.id': pollId
    }, {
      $set: {
        'polls.$.options': poll.options
      }
    });
  },
  'saveKV': function saveKV(key, value) {
    var kv = KV.findOne({
      'key': key
    });
    KV.update({
      'key': key
    }, {
      $set: {
        'value': value
      }
    });
  },
  'user.setLocale': function userSetLocale(locale) {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        updatedAt: new Date(),
        'profile.locale': locale
      }
    });
  },
  'user.update': function userUpdate(profile, newUsername) {
    var oldUsername = Meteor.user().emails[0].address; // console.log('oldUsername', oldUsername)
    // console.log('newUsername', newUsername)
    // console.log('test', oldUsername !== newUsername)

    if (oldUsername !== newUsername) {
      // console.log('GGGGGGGGGGGGGGGGGGGGGGOOOD')
      Accounts.addEmail(this.userId, newUsername);
      Accounts.removeEmail(this.userId, oldUsername); // Accounts.setUsername(Meteor.userId(), newUsername)
    }

    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        updatedAt: new Date(),
        'profile.email': newUsername,
        'profile.name': profile.name // 'profile.city': profile.city,
        // 'profile.number': profile.number,
        // 'profile.centerCoordinates': profile.centerCoordinates,
        // 'profile.pdokv2': profile.pdokv2,
        // 'profile.pdokv2_query': profile.pdokv2_query

      }
    });
  },
  'user.updateHome': function userUpdateHome(coordinates) {
    // console.log('--- update HOME marker coordinates: ', coordinates)
    if (coordinates && coordinates[0] && coordinates[1]) {
      Meteor.users.update({
        _id: Meteor.userId()
      }, {
        $set: {
          updatedAt: new Date(),
          'profile.centerCoordinates': coordinates
        }
      });
    }
  },
  createUpdateContact: function createUpdateContact(data) {
    HTTP.call('POST', 'https://api.brevo.com/v3/contacts', {
      headers: {
        'api-key': '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'
      },
      data: data
    }, Meteor.bindEnvironment(function (error, response, body) {
      console.log(response);

      if (!error && response.statusCode === 200) {
        var content = JSON.parse(response.content);

        if (content.status === 200) {
          console.log('\x1b[32m%s\x1b[0m', content);
        } else {
          console.log(content.status);
          console.log(_typeof(content.status));
          console.log('\x1b[31m%s\x1b[0m', response.content);
        }
      } else if (error) {
        var aMailError = {
          user: Meteor.userId() ? Meteor.userId() : data.attributes && data.attributes.EXT_ID ? data.attributes.EXT_ID : null,
          code: response.statusCode,
          error: error,
          data: data,
          method: 'createUpdateContact'
        };
        MailErrors.insert(aMailError);
        console.log('\x1b[31m%s\x1b[0m', 'ERROR: ' + error);
      }
    }, function (e) {
      console.log('\x1b[31m%s\x1b[0m', e);
    }));
  },

  /*    addTestContactBrevo (){
          HTTP.call(
              'POST',
              'https://api.brevo.com/v3/contacts',
              {
                  headers: { 'api-key': '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' },
                  data: { // Use the 'data' key for the message body
                      "attributes": {
                          "FIRSTNAME": "MICK4",
                          "LASTNAME": "Dobbel3",
                          "FOO": 'BARR',
                      },
                      /!*"params": {
                          "FOO": "BAR",
                          "MVD_URL": "https://example.com/cart/12345",
                          // "firstname":"JOHN"
                      },*!/
                      "email": "dobbel01@hotmail.com",
                      "emailBlacklisted": false,
                      "smsBlacklisted": false,
                      updateEnabled: true
                  },
              },
               Meteor.bindEnvironment(
                  function (error, response, body) {
                      console.log(response)
                      if (!error && response.statusCode === 200) {
                           var content = JSON.parse(response.content)
                           if (content.status === 200) {
                               console.log('\x1b[32m%s\x1b[0m', content)
                           } else {
                              console.log(content.status)
                              console.log(typeof (content.status))
                              console.log('\x1b[31m%s\x1b[0m', response.content)
                          }
                      } else if(error){
                          console.log('\x1b[31m%s\x1b[0m', "ERROR: " + error)
                      }
                  },
                  function (e) {
                      console.log('\x1b[31m%s\x1b[0m', e)
                  }
              ))
        },*/
  sendTestEmailBrevo: function sendTestEmailBrevo() {
    console.log('sendTestEmailBrevo');
    /*async function postData(url, data) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data), // stringify the JSON object
            });
             if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
             const responseData = await response.json();
            console.log(responseData);
        } catch (error) {
            console.error('Post error:', error);
        }
    }*/
    // HTTP.call('POST', 'http://ptsv2.com/t/beeapp/post', { params: file },

    HTTP.call('POST', 'https://api.brevo.com/v3/smtp/email', {
      headers: {
        'api-key': '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'
      },
      data: {
        // Use the 'data' key for the message body
        'templateId': 1,
        'sender': {
          'name': 'Greenmapper Friends',
          'email': 'friends@greenmapper.org'
        },
        'to': [{
          'email': 'dobbel01@hotmail.com'
        }],
        'params': {
          'FOO': 'BAR',
          'MVD_URL': 'https://example.com/cart/123456',
          'firstname': 'JOHN'
        } // 'subject': 'My first email from the Brevo API',
        // 'htmlContent': '<html><body><p>This is the HTML content of your email.</p></body></html>',
        // 'textContent': 'This is the text content of your email.'

      }
    }, Meteor.bindEnvironment(function (error, response, body) {
      console.log(response);

      if (!error && response.statusCode === 200) {
        var content = JSON.parse(response.content);

        if (content.status === 200) {
          console.log('\x1b[32m%s\x1b[0m', content);
        } else {
          console.log(content.status);
          console.log(_typeof(content.status));
          console.log('\x1b[31m%s\x1b[0m', response.content);
        }
      } else if (error) {
        var data = {
          'foo': 'bar'
        };
        var aMailError = {
          user: Meteor.userId(),
          code: response.statusCode,
          error: error,
          data: data
        };
        MailErrors.insert(aMailError);
        console.log('\x1b[31m%s\x1b[0m', 'ERROR: ' + error);
      }
    }, function (e) {
      console.log('\x1b[31m%s\x1b[0m', e);
    })); //const myData = { key: 'value' };
    // postData('https://api.example.com/submit', myData);

    /*  let emailAPI = new TransactionalEmailsApi();
      emailAPI.authentications.apiKey.apiKey = "xkeysib-xxxxxxxxxxxxxxxxxxxxx"
       let message = new SendSmtpEmail();
      message.subject = "First email";
      message.textContent = "Hello world!";
      message.sender = { name: "John Doe", email: "john.doe@example.com" };
      message.to = [{ email: "jane.smith@example.com", name: "Jane Smith" }];
    */
  },
  sendTestEmail: function sendTestEmail() {
    console.log('sendTestEmail');
    process.env.MAIL_URL = 'smtp://172.17.0.1:25'; // Make sure that all arguments are strings.
    //check([to, from, subject, text], [String]);
    // Let other method calls from the same client start running, without
    // waiting for the email sending to complete.

    this.unblock();
    var to = 'dobbel01@hotmail.com';
    var from = 'friends@greenmapper.org';
    var subject = 'Test mail send from greenmapper meteor';
    var text = 'Test email text foo bar bla';
    var message;

    try {
      Email.send({
        to: to,
        from: from,
        subject: subject,
        text: text
      }); // to = 'minne@deontwikkelfabriek.nl'
      // Email.send({ to, from, subject, text });
    } catch (err) {
      console.log('CATCH ERRROR'); //console.log(err.message);
      // console.log(err.code);

      var errM = JSON.stringify(err, Object.getOwnPropertyNames(err));
      console.log(errM);
      message = errM;
    }

    return {
      status: 200,
      // message: 'this is a server test mail response :)'
      message: message
    }; // return Email.sendAsync({ to, from, subject, text }).catch(err => {
    //     //
    // });
  },
  sendTestEmail2: function sendTestEmail2() {
    process.env.MAIL_URL = 'smtp://172.17.0.1:587 ';
    console.log('sendTestEmail2'); // Make sure that all arguments are strings.
    //check([to, from, subject, text], [String]);
    // Let other method calls from the same client start running, without
    // waiting for the email sending to complete.

    this.unblock();
    var to = 'dobbel01@hotmail.com';
    var from = 'friends@greenmapper.org';
    var subject = 'Test mail send from greenmapper meteor 2';
    var text = 'Test email text foo bar bla 2';
    var message;

    try {
      Email.send({
        to: to,
        from: from,
        subject: subject,
        text: text
      }); // to = 'minne@deontwikkelfabriek.nl'
      // Email.send({ to, from, subject, text });
    } catch (err) {
      console.log('CATCH ERRROR2');
      console.log(err.message);
      message = err.message;
    }

    return {
      status: 200,
      // message: 'this is a server test mail response :)'
      message: message
    }; // return Email.sendAsync({ to, from, subject, text }).catch(err => {
    //     //
    // });
  },
  sendTestEmails: function sendTestEmails() {
    process.env.MAIL_URL = 'smtps://172.17.0.1:465 ';
    console.log('sendTestEmail S'); // Make sure that all arguments are strings.
    //check([to, from, subject, text], [String]);
    // Let other method calls from the same client start running, without
    // waiting for the email sending to complete.

    this.unblock();
    var to = 'dobbel01@hotmail.com';
    var from = 'friends@greenmapper.org';
    var subject = 'Test mail send from greenmapper meteor S';
    var text = 'Test email text foo bar bla S';
    var message;

    try {
      Email.send({
        to: to,
        from: from,
        subject: subject,
        text: text
      }); // to = 'minne@deontwikkelfabriek.nl'
      // Email.send({ to, from, subject, text });
    } catch (err) {
      console.log('CATCH ERRROR2');
      console.log(err.message);
      message = err.message;
    }

    return {
      status: 200,
      // message: 'this is a server test mail response :)'
      message: message
    }; // return Email.sendAsync({ to, from, subject, text }).catch(err => {
    //     //
    // });
  },
  'error.gen': function errorGen(message) {
    console.log('ERROR server');
    var a = 1 / 0;
    console.log(a); // Meteor.call('error.gen')

    throw new Error('Meteorr SERVER test error: ' + new Date().getTime());
  },
  'log': function log(message) {
    console.log('HALLO2');
    console.log(message);
  },

  /**
   * upload base64 image method
   *
   * @param {*} file
   *
   * @param {string}     file.userid
   * @param {string}     file.type
   * @param {number}     file.size
   * @param {string}     file.name
   * @param {string}     file.extension - file extension
   * @param {string}     file.content   - base64 string
   */
  uploadImageFileBase64: function uploadImageFileBase64(base64Image, threadUUID, fileUUID) {
    console.log('uploadImageFileBase64 CALLEDd MVD'); // var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
    // console.log(base64regex.test('SomeStringObviouslyNotBase64Encoded...'))
    // console.log(base64regex.test('U29tZVN0cmluZ09idmlvdXNseU5vdEJhc2U2NEVuY29kZWQ='))

    var file = {
      content: base64Image,
      userid: threadUUID,
      //Meteor.userId(),
      extension: '.jpg',
      name: 'test',
      measureid: fileUUID
    }; // console.log('content', base64Image.test(file.content))
    // console.log(file)
    // if (Meteor.userId()) {

    var date = new Date();
    var time = date.toLocaleDateString() + ' ' + date.toLocaleTimeString(); // Meteor.http.post(Meteor.settings.public.uploadImgUrl, { params: file },
    // HTTP.call('POST', 'http://217.21.192.155/beeapp/php/services/img.upload.php', { params: file },
    // HTTP.call('POST', 'https://cdnbij.deontwikkelfabriek.nl/php/services/img.upload.php', { params: file },
    // HTTP.call('POST', Meteor.settings.public.uploadImgUrl, { params: file },

    HTTP.call('POST', 'https://cdn.greenmapper.org/php/services/img.upload.php' + '', {
      params: file
    }, // HTTP.call('POST', 'http://ptsv2.com/t/beeapp/post', { params: file },
    Meteor.bindEnvironment(function (error, response, body) {
      // console.log(response)
      if (!error && response.statusCode === 200) {// console.log("AAP")
        // console.log(response)

        /*
        console.log("JSON PARSE ERROR ")
        var content = JSON.parse(response)
        console.log("KOE")
        console.log(content)
         if (content.status === 200) {
            // console.log('uploadImageFileBase64: Image uploaded')
            // var id = Images.insert({
            //     measureId: measureId,
            //     userid: Meteor.userId(),
            //     // name: content.name,
            //     // originalName: file.name.substring(0, file.name.lastIndexOf('.')),
            //     // originalFile: file.name,
            //     file: content.file,
            //     ext: content.ext,
            //     original: '/images/original/' + content.userid + '/' + content.name + '.' + content.ext,
            //     medium: '/images/medium/' + content.userid + '/' + content.name + '.' + content.ext,
            //     thumb: '/images/thumb/' + content.userid + '/' + content.name + '.' + content.ext,
            //     square: '/images/square/' + content.userid + '/' + content.name + '.' + content.ext
            // })
            // console.log('\x1b[32m%s\x1b[0m', 'SAVED image [id: ' + id + ', name:' + content.name + ', file:' + content.file + ', userid: ' + content.userid + '] - ' + time)
            // console.log('\x1b[32m%s\x1b[0m', 'SAVED image [id: ' + id + ', name:' + content.name + ', file:' + content.file + ', userid: ' + content.userid + '] - ' + time)
            // let imagename = content.name + '.' + content.ext
            // Measures.update({ _id: measureId }, { $set: { 'properties.photo': imagename } })
            // console.log('imagename: ' + imagename)
        } else {
            console.log("Z")
            console.log(content.status)
            console.log(typeof (content.status))
            console.log('\x1b[31m%s\x1b[0m', response.content)
        }*/
      } else {
        console.log('Y');
        console.log('\x1b[31m%s\x1b[0m', 'Exception url handler [' + Meteor.settings.public.uploadImgUrl + '] - ' + time);
      }
    }, function (e) {
      console.log('Q');
      console.log('\x1b[31m%s\x1b[0m', e);
    })); // } else {
    //     return {
    //         status: 530,
    //         message: 'Not logged in'
    //     }
    // }
  },

  /**
   * upload base64 image method
   *
   * @param {*} file
   *
   * @param {string}     file.userid
   * @param {string}     file.type
   * @param {number}     file.size
   * @param {string}     file.name
   * @param {string}     file.extension - file extension
   * @param {string}     file.content   - base64 string
   */
  uploadImageFileBase64OLD: function uploadImageFileBase64OLD(base64Image, measureId) {
    console.log('uploadImageFileBase64 CALLEDd MVD'); // var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
    // console.log(base64regex.test('SomeStringObviouslyNotBase64Encoded...'))
    // console.log(base64regex.test('U29tZVN0cmluZ09idmlvdXNseU5vdEJhc2U2NEVuY29kZWQ='))

    var file = {
      content: base64Image,
      userid: Meteor.userId(),
      extension: 'jpg',
      measureid: measureId
    }; // console.log(base64regex.test(file.content))
    // console.log(file)

    console.log('---------------------V=1--------------'); // if (Meteor.userId()) {

    var date = new Date();
    var time = date.toLocaleDateString() + ' ' + date.toLocaleTimeString(); // Meteor.http.post(Meteor.settings.public.uploadImgUrl, { params: file },
    // HTTP.call('POST', 'http://217.21.192.155/beeapp/php/services/img.upload.php', { params: file },
    // HTTP.call('POST', 'https://cdnbij.deontwikkelfabriek.nl/php/services/img.upload.php', { params: file },

    HTTP.call('POST', Meteor.settings.public.uploadImgUrl, {
      params: file
    }, // HTTP.call('POST', 'http://ptsv2.com/t/beeapp/post', { params: file },
    Meteor.bindEnvironment(function (error, response, body) {
      console.log(response);

      if (!error && response.statusCode === 200) {
        var content = JSON.parse(response.content);

        if (content.status === 200) {
          var id = Images.insert({
            measureId: measureId,
            userid: Meteor.userId(),
            // name: content.name,
            // originalName: file.name.substring(0, file.name.lastIndexOf('.')),
            // originalFile: file.name,
            file: content.file,
            ext: content.ext,
            original: '/images/original/' + content.userid + '/' + content.name + '.' + content.ext,
            medium: '/images/medium/' + content.userid + '/' + content.name + '.' + content.ext,
            thumb: '/images/thumb/' + content.userid + '/' + content.name + '.' + content.ext,
            square: '/images/square/' + content.userid + '/' + content.name + '.' + content.ext
          });
          console.log('\x1b[32m%s\x1b[0m', 'SAVED image [id: ' + id + ', name:' + content.name + ', file:' + content.file + ', userid: ' + content.userid + '] - ' + time); // console.log('\x1b[32m%s\x1b[0m', 'SAVED image [id: ' + id + ', name:' + content.name + ', file:' + content.file + ', userid: ' + content.userid + '] - ' + time)
          // let imagename = content.name + '.' + content.ext
          // Measures.update({ _id: measureId }, { $set: { 'properties.photo': imagename } })
          // console.log('imagename: ' + imagename)
        } else {
          console.log(content.status);
          console.log(_typeof(content.status));
          console.log('\x1b[31m%s\x1b[0m', response.content);
        }
      } else {
        console.log('\x1b[31m%s\x1b[0m', 'Exception url handler [' + Meteor.settings.public.uploadImgUrl + '] - ' + time);
      }
    }, function (e) {
      console.log('\x1b[31m%s\x1b[0m', e);
    })); // } else {
    //     return {
    //         status: 530,
    //         message: 'Not logged in'
    //     }
    // }
  },

  /*    sendEmail (to, from, subject, text) {
          // Make sure that all arguments are strings.
          check([to, from, subject, text], [String])
           // Let other method calls from the same client start running, without
          // waiting for the email sending to complete.
          this.unblock()
           console.log('EMAIL ADRESS')
          console.log(to)
          console.log('EMAIL SUBJECT')
          console.log(subject)
          console.log('EMAIL TEXT')
          console.log(text)
           const bcc = 'friends@greenmapper.org'
           Email.send({ to, from, subject, text })
      },*/
  sendTestTemplateMail: function sendTestTemplateMail(emailAddress, id) {
    console.log('sendTestTemplateMail', emailAddress);
    var template = KV.findOne({
      'id': id
    });
    var body = template.value.body;
    template.value.params.forEach(function (param) {
      body = replaceAll(body, param, param + '_>REPLACED<'); //body = body.replace(param, param+'_>REPLACED<')
    });
    console.log(body);
    Meteor.call('sendHtmlEmail', emailAddress, 'friends@greenmapper.org', template.value.title, body);
  },
  sendTemplatedEmail: function sendTemplatedEmail(emailAddress, template, data) {
    var body = template.value.body;
    data.forEach(function (param) {
      body = replaceAll(body, param.key, param.value);
    }); //greenmapper@mail4qa.com

    Meteor.call('sendHtmlEmail', emailAddress, 'friends@greenmapper.org', template.value.title, body);
  },
  sendHtmlEmail: function sendHtmlEmail(to, from, subject, html) {
    html = '<!DOCTYPE html><html lang="en"><head> <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' + html + '</head></html>';
    console.log('CALLED: sendHtmlEmail => ' + to); // Make sure that all arguments are strings.

    check([to, from, subject, html], [String]); // Let other method calls from the same client start running, without
    // waiting for the email sending to complete.

    this.unblock(); // let text = 'bla die bla bla MVD test'

    /*console.log('EMAIL ADRESS')
    console.log(to)
    console.log('EMAIL SUBJECT')
    console.log(subject)
    console.log('EMAIL html')
    console.log(html)*/

    var bcc = 'friends@greenmapper.org';
    var currentEnv = Meteor.settings.public && Meteor.settings.public.environment;

    if (currentEnv === 'prod') {
      Email.send({
        to: to,
        bcc: bcc,
        from: from,
        subject: subject,
        html: html
        /*,text*/

      });
    } else {
      console.log('Email.send DENIED: ' + currentEnv);
    }
  }
});